import { SeatPosition } from 'hooks/useEllipticalPositions';
import { CardPosition } from '../../SeatWithPlayer/SeatCards';

/**
 * EN-10520 — hole cards anchor to the LEFT of the seat card on EVERY seat.
 *
 * They used to follow the seat's outer side (left seats → left, everyone else →
 * right), which pushed the right-hand column's cards toward the viewport edge
 * and clipped them at 390px. Anchoring them left everywhere fixes that, and
 * reads consistently: every avatar holds their cards in the same hand.
 *
 * The seat position is no longer consulted, but the signature is kept so call
 * sites (and the SeatPosition-typed prop chain through the seat modes) don't
 * have to change — the side is a layout decision, not a per-seat one.
 */
export const useCardPosition = (_position?: SeatPosition): CardPosition => CardPosition.Left;
